import styled from '@emotion/styled';

import { useValidateImage } from '@common/hooks';

import type { PreviewData } from '../../../../type/common.type';

interface PreviewInfoProps {
  preview: PreviewData;
}

export const PreviewInfo = ({ preview }: PreviewInfoProps) => {
  if (!preview || (!preview.code && !preview.image_url && !preview.webp_image_url)) {
    return null;
  }

  return (
    <PreviewSection>
      <Preview code={preview.code} image_url={preview.image_url} webp_image_url={preview.webp_image_url} />
    </PreviewSection>
  );
};

const Preview = ({ code, image_url, webp_image_url }: PreviewData) => {
  const { loaded, isImageValid } = useValidateImage(image_url);
  // TODO: 추후 static 이미지 마이그레이션 마치면 제거
  const { isImageValid: isWebpImageValid } = useValidateImage(webp_image_url);

  // 이미지가 로드되지 않은 경우 레이아웃 시프트 방지를 위해 이미지 영역 표시
  if (image_url && (!loaded || isImageValid)) {
    return (
      <OptionPreview>
        <OptionImage>
          {isWebpImageValid && <source srcSet={webp_image_url || ''} type='image/webp' />}
          <Image src={image_url} alt='상품 옵션 이미지' />
        </OptionImage>
      </OptionPreview>
    );
  }

  if (code) {
    return (
      <ColorPreview>
        <ColorCode code={code} />
      </ColorPreview>
    );
  }

  return null;
};

const PreviewSection = styled.div`
  margin-left: -4px;
  margin-right: 8px;
  align-self: center;
`;

const OptionPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
`;

const OptionImage = styled.picture`
  width: 100%;
  height: 100%;
  border-radius: 4px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ColorPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
`;

const ColorCode = styled.span<{ code: string | null }>`
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 18px;
  height: 18px;
  border-radius: 12px;
  ${({ code }) => code && `background-color: ${code}`}
`;
